import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes, Link, BrowserRouter } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import Card from 'react-bootstrap/Card';
import { AboutUs } from "./aboutus.js";
import { SignUp } from "./signup.js";
import './App.css';

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/signup" element={<SignUp />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

// Header component
function Header() {
  return (
    <div className="container2">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={2}></Col>
          <Nav className="justify-content-center">
            <Nav.Item className="nav"><Link to="/" className="link">Home</Link></Nav.Item>
            <Nav.Item className="nav"><Link to="/aboutus" className="link">About Us</Link></Nav.Item>
            <Nav.Item className="nav"><Link to="/signup" className="link">Sign Up</Link></Nav.Item>
          </Nav>
          <Col xs={12} md={2} className="text-center">
            <img
              className="cafelogo"
              src="https://t4.ftcdn.net/jpg/05/14/51/79/360_F_514517927_dXLi1DauUmrCaE3AkElsVgJ1jaYZMcSA.jpg"
              alt="Cafe Logo"
              width={100}
              height={100}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

// Footer component
function Footer() {
  return (
    <>
      <div id="footer">
        <Container>
          <Row>
            <Col xs={12}>
              <Nav className="justify-content-center">
                <Nav.Item className="nav"><Link to="/" className="link">Home</Link></Nav.Item>
                <Nav.Item className="nav"><Link to="/aboutus" className="link">About Us</Link></Nav.Item>
                <Nav.Item className="nav"><Link to="/signup" className="link">Sign Up</Link></Nav.Item>
              </Nav>
            </Col>
          </Row>
        </Container>
      </div>
      <div id="copyrightinfo" className="text-center p-3">
        Copyright &copy; 35 Crimly Avenue, North York, ON <br />
        Contact us: <br />
        Phone: 647-760-7189 <br />
        Email: <a href="mailto:mathew.karram@outlook.com">mathew.karram@outlook.com</a>
      </div>
    </>
  );
}

// Home page
function Home() {
  return <Body />;
}

// Main Body component fetching from AWS Lambda API
function Body() {
  const [menu, setMenu] = useState({ food: [], drinks: [] });
  const [searchKey, setSearchKey] = useState("");
  const [carouselImages, setCarouselImages] = useState([]);

  useEffect(() => {
    fetch("https://ht9jcuxwod.execute-api.us-east-1.amazonaws.com/menu")
      .then((res) => res.json())
      .then((data) => {
        const foodItems = Array.isArray(data.food) ? data.food : [];
        const drinkItems = Array.isArray(data.drinks) ? data.drinks : [];
        setMenu({ food: foodItems, drinks: drinkItems });

        // Pick 3 random food images for the carousel
        const shuffled = [...foodItems].sort(() => 0.5 - Math.random());
        setCarouselImages(shuffled.slice(0, 3).map(item => item.imageUrl));
      })
      .catch((err) => console.error("Failed to fetch menu items:", err));
  }, []);

  const renderItems = (items) =>
    items
      .filter(item =>
        searchKey === "" || (item.name && item.name.toLowerCase().includes(searchKey.toLowerCase()))
      )
      .map(item => (
        <Card key={item.itemId || item.name} className="mb-4 shadow-sm menu-card mx-auto" style={{ maxWidth: '600px' }}>
          <Row className="g-0">
            <Col md={4}>
              <Card.Img
                src={item.imageUrl || "https://via.placeholder.com/150"}
                alt={item.name}
                className="menu-img"
              />
            </Col>
            <Col md={8}>
              <Card.Body>
                <Card.Title>{item.name || "N/A"}</Card.Title>
                <Card.Text>Price: ${item.price !== undefined ? item.price.toFixed(2) : "N/A"}</Card.Text>
                <Card.Text>Calories: {item.nutrition?.calories ?? "N/A"}</Card.Text>
                <Card.Text>Protein: {item.nutrition?.protein ?? "N/A"} g</Card.Text>
                <Card.Text>Fat: {item.nutrition?.fat ?? "N/A"} g</Card.Text>
                <Card.Text>Carbs: {item.nutrition?.carbs ?? "N/A"} g</Card.Text>
                <Card.Text className={item.available ? "text-success" : "text-danger"}>
                  {item.available ? "Available" : "Not available"}
                </Card.Text>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      ));

  return (
    <div className="intro text-center">
      <Container>
        <h1 className="heading1">Welcome to BABA's Cafe!</h1>
        <h2 className="heading2 mb-4">Where we value Health first!</h2>
        <p className="intropar mb-5">
          At BABA's Cafe we know the struggles of going out to eat while on a diet...
        </p>

        {/* Dynamic Carousel */}
        <Carousel className="mb-5 mx-auto" style={{ maxWidth: '600px' }}>
          {carouselImages.length > 0 ? (
            carouselImages.map((pic, i) => (
              <Carousel.Item key={i}>
                <img src={pic} alt={`Food ${i}`} className="d-block w-100 carousel-img" />
              </Carousel.Item>
            ))
          ) : (
            <Carousel.Item>
              <img src="https://via.placeholder.com/400x300?text=Loading..." alt="Loading" />
            </Carousel.Item>
          )}
        </Carousel>

        {/* Search bar */}
        <div className="mb-4">
          <input
            type="text"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            placeholder="Search for food or drinks"
            className="form-control mx-auto"
            style={{ maxWidth: '400px' }}
          />
        </div>

        {/* Menu items */}
        <h2 className="menu-section-title">Food</h2>
        {menu.food.length > 0 ? renderItems(menu.food) : <p>Loading food items...</p>}

        <h2 className="menu-section-title">Drinks</h2>
        {menu.drinks.length > 0 ? renderItems(menu.drinks) : <p>Loading drink items...</p>}

        {menu.food.length === 0 && menu.drinks.length === 0 && (
          <p style={{ color: "bisque" }}>Sorry, we don’t carry that item!</p>
        )}
      </Container>
    </div>
  );
}